// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__39HmN","Label":"Input_Label__2n7MW","InputElement":"Input_InputElement__2IQ3p","Invalid":"Input_Invalid__R7zS4"};